import { ThunkAction, ThunkDispatch } from 'redux-thunk';
import { AnyAction } from 'redux';
import { UPDATE_GOOGLE_SHEETS_TEMPLATES } from '../actionTypes';
import GoogleSheetsService from '../../services/GoogleSheetsService';
import LocalStorageService from '../../services/LocalStorageService';

export interface GoogleSheetTemplate {
  id: number;
  tabName: string | null;
  googleSheetId?: number;
  menusCsv?: string;
}

export const getGoogleSheetsTemplates = (): ThunkAction<void, {}, {}, AnyAction> =>
  async (dispatch: ThunkDispatch<{}, {}, AnyAction>) => {
    try {
      const templates: any = await GoogleSheetsService.allGoogleSheetHtmlTemplates('', '');

      // Filter templates that have menusCsv defined (these are meant for side menu)
      const menuTemplates = (templates || [])
        .filter((t: any) => t.menusCsv && t.menusCsv.trim().length > 0)
        .map((t: any) => ({
          id: t.id,
          tabName: t.tabName || `Template ${t.id}`,
          googleSheetId: t.googleSheetId,
          menusCsv: t.menusCsv
        }));

      // Save to localStorage for persistence across page refreshes
      const localStorageService = LocalStorageService.getService();
      localStorageService.setGoogleSheetsTemplates(menuTemplates);

      dispatch({
        type: UPDATE_GOOGLE_SHEETS_TEMPLATES,
        data: menuTemplates
      });
    } catch (error) {
      console.error('Failed to fetch Google Sheets templates:', error);
      // Dispatch empty array on error
      dispatch({
        type: UPDATE_GOOGLE_SHEETS_TEMPLATES,
        data: []
      });
    }
  };

export const loadGoogleSheetsTemplatesFromStorage = (): ThunkAction<void, {}, {}, AnyAction> =>
  (dispatch: ThunkDispatch<{}, {}, AnyAction>) => {
    const localStorageService = LocalStorageService.getService();
    const templates = localStorageService.getGoogleSheetsTemplates();

    dispatch({
      type: UPDATE_GOOGLE_SHEETS_TEMPLATES,
      data: templates
    });
  };

export const updateGoogleSheetsTemplates = (templates: GoogleSheetTemplate[]) => ({
  type: UPDATE_GOOGLE_SHEETS_TEMPLATES,
  data: templates
});
